import { useEffect, useRef, useState } from 'react'

import ConfirmationDialog from '../../ConfirmationDialog/index'
import Input from '../../Input/index'

const AddGuestWithRoomNo = ({ handleSubmit, handleClose }) => {
  const [roomNo, setRoomNo] = useState('')
  const inputRef = useRef()

  useEffect(() => {
    if (inputRef) {
      inputRef.current.focus()
    }
  }, [])

  return (
    <ConfirmationDialog
      title="Add guest"
      isButtonDisabled={roomNo.length < 2}
      positiveMessage="Next"
      negativeMessage="Cancel"
      onConfirm={() => handleSubmit(roomNo)}
      onClose={handleClose}
      actLikeForm={true}
      hasFixedTopMargin={true}
    >
      <Input
        forwardedRef={inputRef}
        autoComplete="off"
        label="Room no"
        name="guestFirstName"
        handleChange={e => setRoomNo(e.target.value)}
        value={roomNo}
        isFullWidth
        style={{ marginBottom: -10 }}
      />
      <button
        style={{ color: '#4079F5', fontSize: 14, fontWeight: 500, marginTop: 3 }}
        onClick={() => handleSubmit('N/A')}
      >
        No room number
      </button>
    </ConfirmationDialog>
  )
}

export default AddGuestWithRoomNo
